import { useEffect, useState } from "react";

/**
 * The running server's build version (from GET /api/health), shown in the navbar user menu.
 *
 * This is the authoritative "what's actually deployed" version — it matches the image rolled by the
 * pipeline. Fetched once on mount; returns null until it resolves (and stays null if the call fails).
 */
export function useServerVersion(): string | null {
  const [version, setVersion] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    fetch("/api/health", { cache: "no-store" })
      .then((res) => (res.ok ? res.json() : null))
      .then((data: { version?: string } | null) => {
        if (active && data?.version) setVersion(data.version);
      })
      .catch(() => {
        /* offline / transient — leave null, the menu just shows a placeholder */
      });
    return () => {
      active = false;
    };
  }, []);

  return version;
}
